<template>
    <LegacyConcernElements
        ref="legacyStep"
        :request="context.request"
        :product="context.product"
        :compact-view="settings.compactView"
        :included-substances="context.includedSubstances || []"
        :excluded-substances="context.excludedSubstances || []"
        :components-concern-elements="context.componentConcernSubstances || []"
        :show-product-weight="settings.showProductWeight && context.productWeightRequired"
        :show-product-weight-message="settings.showProductWeightMessage && context.productWeightRequired"
        :show-information-owner-selection="settings.showInformationOwnerSelection !== false"
        @validityChanged="handleValidityChanged"
        @forward="emitAction('forward')"
        @undefined="handleUndefined"
        @include="handleInclude"
        @exclude="handleExclude"
        @excludeModal="handleExclude"
        @substanceChange="handleSubstanceChange"
        @informationOwnerChange="handleInformationOwnerChange"
        @hasConcernSubstances="handleHasConcernSubstances"
        @listQuestionStateUpdated="handleListQuestionStateUpdated"
        @modalClosed="emitAction('selector.closed')"
        @componentsModalClosed="emitAction('components.changed')"
        @componentSubstanceExcludedAndSaved="emitAction('component-substance.saved')"
        @characteristicsChange="handleCharacteristicsChange"
    />
</template>

<script>
import LegacyConcernElements from '@/views/request/received/flow/components/vertiacal-steps/ConcernElements.vue'

export default {
    name: 'ProductConcernSubstancesStep',
    components: {
        LegacyConcernElements,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    data() {
        return {
            pendingExcludedSubstances: [],
            excludeDispatchScheduled: false,
        }
    },
    watch: {
        'context.request.informationOwner': 'synchronizeLegacyState',
        'context.request.isComplexProduct': 'synchronizeLegacyState',
        'context.product.characteristics.weight': 'synchronizeLegacyState',
    },
    mounted() {
        this.synchronizeLegacyState()
    },
    methods: {
        emitAction(type, payload = {}) {
            this.$emit('action', { type, payload })
        },
        synchronizeLegacyState() {
            const { legacyStep } = this.$refs
            if (!legacyStep) {
                return
            }

            legacyStep.informationOwner = this.context.request.informationOwner
            legacyStep.isComplex = this.context.request.isComplexProduct
            legacyStep.weight = this.context.product.characteristics
                ? this.context.product.characteristics.weight
                : null

            if (Object.prototype.hasOwnProperty.call(legacyStep, 'weHaveInformation')) {
                legacyStep.weHaveInformation = legacyStep.hasConcernSubstances
            }

            if (typeof legacyStep.emitValidity === 'function') {
                legacyStep.emitValidity()
            }
        },
        handleValidityChanged(isValid) {
            this.$emit('validity-change', { isValid, errors: [] })
        },
        handleUndefined(substance, save = false) {
            const completionCallback = save ? this.finishLegacyLoading : null
            this.emitAction('substance.undefined', { substance, save, completionCallback })
        },
        finishLegacyLoading() {
            const { legacyStep } = this.$refs
            if (legacyStep) {
                legacyStep.showLoading = false
            }
        },
        handleInclude(substance, substanceListIds = []) {
            this.emitAction('substance.include', { substance, substanceListIds })
        },
        handleExclude(substance) {
            this.pendingExcludedSubstances.push(substance)
            if (this.excludeDispatchScheduled) {
                return
            }

            this.excludeDispatchScheduled = true
            Promise.resolve().then(() => {
                const substances = this.pendingExcludedSubstances.splice(0)
                this.excludeDispatchScheduled = false
                this.emitAction('substances.exclude', { substances })
            })
        },
        handleSubstanceChange(substance, properties, completionCallback = null) {
            this.emitAction('substance-properties.change', { substance, properties, completionCallback })
        },
        handleInformationOwnerChange(informationOwner) {
            this.emitAction('information-owner.change', { informationOwner })
        },
        handleHasConcernSubstances(value) {
            this.emitAction('has-concern-substances.change', { value })
        },
        handleListQuestionStateUpdated(list, state) {
            this.emitAction('list-question.update', { list, state })
        },
        handleCharacteristicsChange(characteristics) {
            this.emitAction('characteristics.change', { characteristics })
        },
    },
}
</script>
